// polyfill from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#polyfill
if (!Object.entries) {
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array

        while (i--)
            resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
    };
}

// polyfill from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN#polyfill
Number.isNaN = Number.isNaN || function isNaN(input) {
    return typeof input === 'number' && input !== input;
};

// polyfill from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat#polyfill
if (!String.prototype.repeat) {
    String.prototype.repeat = function (count) {
        'use strict';
        if (this == null)
            throw new TypeError('can\'t convert ' + this + ' to object');

        var str = '' + this;
        // To convert string to integer.
        count = +count;
        // Check NaN
        if (count != count)
            count = 0;

        if (count < 0)
            throw new RangeError('repeat count must be non-negative');

        if (count == Infinity)
            throw new RangeError('repeat count must be less than infinity');

        count = Math.floor(count);
        if (str.length == 0 || count == 0)
            return '';

        // Ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (str.length * count >= 1 << 28)
            throw new RangeError('repeat count must not overflow maximum string size');

        var maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while (count) {
            str += str;
            count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
    }
}

$(function () {
    function setSlidesFocusability(swiper) {
        $(swiper.slides).each(function (i, e) {
            var slide = $(e);
            slide.is(".swiper-slide-visible") ? slide.children("a").removeAttr("tabindex") : slide.children("a").attr("tabindex", "-1");
        });
    }

    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    var standardSpeed = 300;

    var heroSwiper = new Swiper(".hero-content .swiper-container", {
        speed: prefersReducedMotion.matches ? 0 : standardSpeed,
        slidesPerView: 1,
        slidesPerGroup: 1,
        ally: true,
        watchSlidesVisibility: true,
        spaceBetween: 60,
        pagination: {
            clickable: true,
            el: ".swiper-pagination"
        },
        autoplay: {
            delay: 10000
        }
    });

    var swiper = new Swiper(".section-insurance-products .swiper-container", {
        speed: prefersReducedMotion.matches ? 0 : standardSpeed,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        keyboard: true,
        a11y: true,
        watchSlidesVisibility: true,
        breakpoints: {
            600: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            740: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            920: {
                slidesPerView: 4,
                slidesPerGroup: 4
            },
            1080: {
                slidesPerView: 5,
                slidesPerGroup: 5
            }
        },
        on: {
            init: function (s) {
                $(".swiper-button-prev, .swiper-button-next").addClass("swiper-button-initialized");
            },
            slideChangeTransitionEnd: function (s) {
                setTimeout(function () {
                    setSlidesFocusability(s);
                }, 0);
            },
            breakpoint: function (s) {
                setTimeout(function () {
                    setSlidesFocusability(s);
                }, 0);
            }
        }
    });

    if (prefersReducedMotion.addEventListener) {
        prefersReducedMotion.addEventListener("change", function () {
            heroSwiper.params.speed = prefersReducedMotion.matches ? 0 : standardSpeed;
            swiper.params.speed = prefersReducedMotion.matches ? 0 : standardSpeed;
        });
    }
});
